import { render, staticRenderFns } from "./EquipmentListItem.vue?vue&type=template&id=96dd54ca"
import script from "./EquipmentListItem.vue?vue&type=script&lang=js"
export * from "./EquipmentListItem.vue?vue&type=script&lang=js"
import style0 from "./EquipmentListItem.vue?vue&type=style&index=0&id=96dd54ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports